import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M12.5 21h-6.5a1 1 0 0 1 -1 -1v-16a1 1 0 0 1 1 -1h12a1 1 0 0 1 1 1v8","key":"svg-0"}],["path",{"d":"M16 19a3 3 0 1 0 6 0a3 3 0 1 0 -6 0","key":"svg-1"}],["path",{"d":"M17 21l4 -4","key":"svg-2"}],["path",{"d":"M11 17a1 1 0 1 0 2 0a1 1 0 0 0 -2 0","key":"svg-3"}]]

const IconDeviceTabletCancel = createReactComponent('outline', 'device-tablet-cancel', 'DeviceTabletCancel', __iconNode);

export default IconDeviceTabletCancel;